import Socket from '../common/socket'

export default new Socket(`${process.env.REACT_APP_WEBSOCKET_MESSAGE_URL}/odin-websocket/ws`)
